import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { EventOtherTravelLegForm } from "Bands/components";
import {
  BAND_ACTIONS,
  IEventOtherTravelLegParams,
  TravelLegType,
} from "Bands/types";
import { copy } from "shared/assets";
import { IAPIState, IFormButtons, IStatus } from "shared/types";
import { createTravelLeg, dataMetaSelector } from "Bands/state";
import { addTemporaryToast } from "shared/components/Toast";
import { Modal } from "shared/components";
import { Plus } from "shared/assets/icons";
import { API_ENDPOINTS } from "shared/constants";
import { useClearActionMetaOnUnMount } from "Bands/utils";

const createCopy = copy.travelBlock.other.create;

interface Props {
  blockId: string;
  handleClose: () => void;
}

export const CreateOtherTravelLegModal: React.FC<Props> = ({
  blockId,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.createTravelLeg)
  );

  useClearActionMetaOnUnMount(BAND_ACTIONS.createTravelLeg);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: createCopy.messages.success,
        })
      );

      handleClose();
    }
  }, [apiMeta?.status, dispatch, handleClose]);

  const handleAdd = (data: IEventOtherTravelLegParams) => {
    const cleanData: IEventOtherTravelLegParams = {
      travelBlock: API_ENDPOINTS.EVENT_TRAVEL_BLOCK(blockId),
      ...data,
    };

    dispatch(
      createTravelLeg({
        data: cleanData,
        travelLegType: TravelLegType.other,
      })
    );
  };

  const buttons: IFormButtons = useMemo(
    () => ({
      primary: {
        children: createCopy.buttons.create,
        "data-testid": "other_travel_leg_submit",
      },
      secondary: {
        onClick: handleClose,
      },
    }),
    [handleClose]
  );

  return (
    <Modal title={createCopy.title} icon={Plus}>
      <EventOtherTravelLegForm
        buttons={buttons}
        handleSubmit={handleAdd}
        isSubmitting={apiMeta?.status === IAPIState.pending}
        apiError={apiMeta?.error}
        error={!!apiMeta?.error}
      />
    </Modal>
  );
};
